<template>
  <div class="page">
    <sui-segment class="content" padded attached emphasis="secondary">
      <sui-container>
        <h2 class="ui header">
          <i class="folder grey icon" />
          <sui-header-content>Project {{project.name}}</sui-header-content>
        </h2>
        <sui-message icon="exclamation circle" dismissable error header="Error!" :content="error" v-show="error" @dismiss="error = null" />
        <sui-segment class="actions">
          <div style="float: right">
            <sui-button-group color="red" floated="right">
              <sui-button class="icon labeled" icon="trash" :disabled="!access.projectDestroy" @click="destroy()" data-goal="PROJECT_PAGE_DESTROY">Destroy</sui-button>
              <sui-dropdown class="icon" button icon="dropdown">
                <sui-dropdown-menu>
                  <sui-dropdown-item :disabled="isEmptyDisabled" data-goal="PROJECT_PAGE_EMPTY" @click="empty()">
                    Destroy all services<br>
                    <small class="dropdown-item-description">Start destroying for all {{services.length}} services of the project.</small>
                  </sui-dropdown-item>
                  <sui-dropdown-item :disabled="isEmptyDisabled" data-goal="PROJECT_PAGE_EMPTY_FORCE" @click="empty(true)">
                    Force destroy all services<br>
                    <small class="dropdown-item-description">Start destroying for all {{services.length}} services of the project.<br>Instantly remove the services from D2C, ignore all errors.</small>
                  </sui-dropdown-item>
                </sui-dropdown-menu>
              </sui-dropdown>
            </sui-button-group>
          </div>
          <sui-button color="blue" icon="edit" label-position="left" :disabled="!access.projectUpdate" @click.prevent="$modals.updateProject.open(project, 'renaming')" data-goal="PROJECT_PAGE_RENAME">Rename</sui-button>
        </sui-segment>
        <br>
        <br>
        <ServiceCards header="Services" :services="services" />
        <br>
        <br>
        <HostCards header="Hosts of services" :list="hosts" :newHost="false" />
      </sui-container>
    </sui-segment>
  </div>
</template>

<script>
  import orderBy from 'lodash/orderBy'
  import {mapGetters} from 'vuex'
  import HostCards from '@/components/cards/Hosts'
  import ServiceCards from '@/components/cards/Services'
  import store from '@/store'
  import utils from '@/utils'

  export default {
    name: 'ProjectView',
    components: {
      HostCards,
      ServiceCards,
    },
    data() {
      return {
        error: null
      }
    },
    computed: {
      ...mapGetters(['access', 'config', 'projects']),
      project() {
        const name = decodeURIComponent(this.$route.params.project)
        const project = this.projects.find(entity => entity.id === name || entity.name === name)
        return project
      },
      services() {
        return orderBy(this.project._services, ['created'], ['desc'])
      },
      hosts() {
        return orderBy(this.project._hosts, ['created'], ['desc'])
      },
      isEmptyDisabled() {
        return this.services.some(service => service.process || !service._actions.serviceDestroy) || !this.services.length
      },
    },
    sockets: {
      update(data) {
        if (data.target === 'project' && data.id === this.project.id && data.name) {
          this.$router.push(`/projects/${data.name}`)
        }
      },
      delete(data) {
        if (data.target === 'project' && data.id === this.project.id) {
          this.$router.push({path: '/error/not-exist', query: {project: this.project.name}})
        }
      },
    },
    methods: {
      empty(force) {
        return this.$modals.confirm.open({
          callback: () => {
            this.project._services.forEach(service => {
              service.destroy(force)
            })
          },
        })
      },
      destroy() {
        return this.$modals.confirm.open({
          callback: () => {
            this.error = null
            utils.reachGoal('PROJECT_PAGE_DESTROY_TRY')
            this.project.destroy().then(() => {
              utils.reachGoal('PROJECT_PAGE_DESTROY_SUCCESS')
              this.$router.push(this.config.homePath)
            }).catch(error => {
              utils.reachGoal('PROJECT_PAGE_DESTROY_FAIL')
              this.error = error.message
            })
          },
        })
      },
    },
    beforeRouteEnter(to, from, next) {
      const name = decodeURIComponent(to.params.project)
      const project = store.getters.projects.find(entity => entity.id === name || entity.name === name)
      if (project) {
        next()
      } else {
        next({path: '/error/not-exist', query: {project: name}})
      }
    },
  }
</script>

<style scoped>
  .page { display: flex; flex-direction: column; }
  .page > .header { display: flex; align-items: center; justify-content: space-between; }
  .page > .content { flex: 1; }
</style>
